<template>
  <div class="app-container">
    <el-form :inline="true" :model="queryParams" class="demo-form-inline">
      <el-form-item label="租户">
        <el-select v-model="queryParams.tenantId" placeholder="请选择租户" clearable style="width: 200px">
          <el-option v-for="tenant in tenantList" :key="tenant.tenantId" :label="tenant.name" :value="tenant.tenantId" />
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-card>
          <div slot="header">总会话数</div>
          <div class="stat-number">{{ statistics.totalConversations || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">已完成会话</div>
          <div class="stat-number">{{ statistics.completedConversations || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">平均响应时间</div>
          <div class="stat-number">{{ statistics.avgResponseTime || 0 }} s</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">平均评分</div>
          <div class="stat-number">{{ statistics.avgRating || 0 }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">会话趋势</div>
          <div id="trendChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">会话分布</div>
          <div id="distributionChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getTenantStatistics, getConversationTrend } from '@/api/statistics'
import { listTenants } from '@/api/tenant'
import * as echarts from 'echarts'

export default {
  name: 'StatisticsOverview',
  data() {
    return {
      queryParams: {
        tenantId: undefined
      },
      dateRange: [],
      statistics: {},
      tenantList: [],
      trendChart: null,
      distributionChart: null
    }
  },
  mounted() {
    this.getTenantList()
    this.initDateRange()
    this.initCharts()
    this.loadData()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
      })
    },
    initDateRange() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.dateRange = [start, end]
    },
    initCharts() {
      this.trendChart = echarts.init(document.getElementById('trendChart'))
      this.distributionChart = echarts.init(document.getElementById('distributionChart'))
    },
    async loadData() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('请选择日期范围')
        return
      }

      try {
        const startDate = this.formatDate(this.dateRange[0])
        const endDate = this.formatDate(this.dateRange[1])
        
        const res = await getTenantStatistics({
          tenantId: this.queryParams.tenantId,
          startDate,
          endDate
        })
        
        // 映射数据结构
        const currentPeriod = res.data.currentPeriod || {}
        this.statistics = {
          totalConversations: currentPeriod.totalConversations || 0,
          completedConversations: currentPeriod.resolvedConversations || 0,
          inProgressConversations: currentPeriod.totalConversations - currentPeriod.resolvedConversations || 0,
          queuedConversations: 0,
          avgResponseTime: currentPeriod.avgResponseTime || 0,
          avgRating: currentPeriod.avgRating || 0
        }
        
        // 加载趋势数据
        const trendRes = await getConversationTrend({
          tenantId: this.queryParams.tenantId,
          startDate,
          endDate,
          interval: 'day'
        })
        
        this.renderTrendChart(trendRes.data)
        this.renderDistributionChart()
      } catch (error) {
        console.error(error)
      }
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    renderTrendChart(data) {
      this.trendChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: data.dates || []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data.conversationCounts || [],
          type: 'line',
          smooth: true,
          areaStyle: {}
        }]
      })
    },
    renderDistributionChart() {
      this.distributionChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              { value: this.statistics.completedConversations || 0, name: '已完成' },
              { value: this.statistics.inProgressConversations || 0, name: '进行中' },
              { value: this.statistics.queuedConversations || 0, name: '排队中' }
            ]
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.stat-number {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  color: #409EFF;
}
.mt-20 {
  margin-top: 20px;
}
</style>
